import { render, staticRenderFns } from "./icon-alert-octagon.vue?vue&type=template&id=a89ad6b2&"
import script from "./icon-alert-octagon.vue?vue&type=script&lang=js&"
export * from "./icon-alert-octagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports